export default "__VITE_ASSET__eJVd00mE__"